import { render, staticRenderFns } from "./DeVideo.vue?vue&type=template&id=533d77a0"
import script from "./DeVideo.vue?vue&type=script&lang=js"
export * from "./DeVideo.vue?vue&type=script&lang=js"
import style0 from "./DeVideo.vue?vue&type=style&index=0&id=533d77a0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('533d77a0')) {
      api.createRecord('533d77a0', component.options)
    } else {
      api.reload('533d77a0', component.options)
    }
    module.hot.accept("./DeVideo.vue?vue&type=template&id=533d77a0", function () {
      api.rerender('533d77a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/canvas/customComponent/DeVideo.vue"
export default component.exports